import { Observable, of, tap } from 'rxjs'
import { catchError, map } from 'rxjs/operators'

import { LangService } from './lang.service'
import { LocalStorageService } from './local-storage.service'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { ApiService } from 'src/app/core/abstracts/api.service'
import { AuthUser } from 'src/app/core/interfaces/auth'
import { SsrService } from 'src/app/core/services/ssr.service'

@Injectable({
  providedIn: 'root',
})
export abstract class AuthService extends ApiService {
  authUser?: AuthUser

  protected constructor(
    override http: HttpClient,
    override ssrService: SsrService,
    override langService: LangService,
    protected storageService: LocalStorageService,
  ) {
    super(http, ssrService, langService)
  }

  auth(): Observable<AuthUser> {
    return this.http.get(`${this.baseUrl}/auth/user`).pipe(
      tap((response: any) => {
        this.authUser = response
        if (this.authUser) {
          this.authUser.walletType = `${this.storageService.getItem('walletType')}`
        }

        console.log(this.authUser)

        return this.authUser
      }),
    )
  }

  login(publicKey: string, message: string, signature: any[], walletType: string): Observable<AuthUser> {
    return this.http.post<AuthUser>(`${this.baseUrl}/auth/login`, { publicKey, message, signature }).pipe(
      tap((response) => {
        this.storageService.setItem('walletType', walletType)
        this.authUser = response
        this.authUser.walletType = walletType
        this.storageService.setItem('token', response.token)

        return response
      }),
    )
  }

  signUp(email: string, password: string): Observable<AuthUser> {
    return this.http.post<AuthUser>(`${this.baseUrl}/auth/signup`, { email, password }).pipe(
      tap((response) => {
        const walletType = 'EMAIL'

        this.storageService.setItem('walletType', walletType)
        this.authUser = response
        this.authUser.walletType = walletType
        this.storageService.setItem('token', response.token)

        return response
      }),
    )
  }

  setNickname(nickname: string, email: string): Observable<AuthUser> {
    return this.http.post<AuthUser>(`${this.baseUrl}/user/update`, { nickname, email }).pipe(
      tap(() => {
        if (this.authUser) {
          this.authUser.nickname = nickname
          this.authUser.nickname = email
        }

        return this.authUser
      }),
    )
  }

  logout(): void {
    this.storageService.removeItem('token')
    this.authUser = undefined
  }
}
